module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Aubin-coat_of_arms-0bb88d86d7faac69ed84295b44132412.svg";